export const CommissionMyRouting = [
    {
      path: "/project/commission/my",
      name: "project-commissionMy-list",
      meta: { title: "我的提成" },
      notice: {  },
      component: () =>
        import(
          /* webpackChunkName: "project-commission" */ "@/views/project/commissionMy/list/index.vue"),
    }
  ];